module.exports = "<span class=\"created-by\">Todos os direitos reservados - MessenOcean</span>\n"